import { FormikProps } from 'formik';
import { isArray, mapValues } from 'lodash-es';
import { useEffect } from 'react';
import { ServerError } from 'src/entities/server-errors';

export default function useServerError<T>(formik: FormikProps<T>, error: ServerError<T> | null): void {
  useEffect(() => {
    if (error) {
      formik.setErrors(
        mapValues(error.errors, (fieldErrors) => {
          if (isArray(fieldErrors) && fieldErrors.length) {
            return fieldErrors[0];
          }
        })
      );
    }
  }, [error]);
}
